import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Styles = styled.span.attrs(() => ({ className: 'app-loader' }))`
    &&&.app-loader {
        z-index: 50000;
        position: fixed;

        > .z2-state-loading {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: unset;
            height: unset;
        }

        &.app-loader-global > .z2-state-loading {
            top: 70px;
            left: 90px;
            right: 0;
            bottom: 30px;
        }
    }
`;

export interface LoadingProps {
    global?: boolean;
    delay?: number;
}

export function Loading({ global = false, delay = 0 }: LoadingProps) {
    const [visible, setVisible] = useState(!delay);
    const timeoutRef = useRef<any>(null);

    useEffect(() => {
        if (delay > 0) {
            setVisible(false);

            timeoutRef.current = setInterval(() => {
                setVisible(true);
                timeoutRef.current = null;
            }, delay);
        }

        return () => clearTimeout(timeoutRef.current);
    }, [delay]);

    if (!visible) {
        return null;
    }

    return (
        <Styles className={`app-loader ${global ? 'app-loader-global' : ''}`}>
            {/* @ts-ignore */}
            <div className="z2-state-loading react-loader">
                <span className="spinner">
                    <span className="bounce1"></span>
                    <span className="bounce2"></span>
                    <span className="bounce3"></span>
                </span>
            </div>
        </Styles>
    );
}
